// src/components/admin/AdminComments.tsx
import React, { useEffect, useState } from 'react';
import { API_BASE_URL } from '../../config';

interface Submission {
  id: number;
  name: string;
  email: string;
  message: string;
  submittedAt?: string; // optional if you plan to show timestamps later
}

const AdminComments: React.FC = () => {
  const [submissions, setSubmissions] = useState<Submission[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchSubmissions = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/api/Comments`);
        if (!response.ok) {
          throw new Error(`HTTP error ${response.status}`);
        }
        const data: Submission[] = await response.json();
        setSubmissions(data);
      } catch (err: any) {
        console.error('Error fetching submissions:', err);
        setError('Failed to load submissions.');
      } finally {
        setLoading(false);
      }
    };

    fetchSubmissions();
  }, []);

  return (
    <div>
      <h2>Contact Form Submissions</h2>

      {loading && <p>Loading submissions...</p>}
      {error && <p className="text-danger">{error}</p>}

      {!loading && submissions.length === 0 && <p>No submissions found.</p>}

      {!loading && submissions.length > 0 && (
        <ul>
          {submissions.map((submission) => (
            <li key={submission.id}>
              <strong>{submission.name}</strong> ({submission.email}): {submission.message}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default AdminComments;